export default __webpack_public_path__ + "static/logo-fd76fa36062c43dd66d0f9c70c830436.svg";